<template>
    <div>
        <AdvanceCarePlan />
        <AdditionalComments class="mt-2" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import AdvanceCarePlan from "./AdvanceCarePlan/AdvanceCarePlan.vue";
import AdditionalComments from "./AdditionalComments/AdditionalComments.vue";

export default defineComponent({
    components: {
        AdvanceCarePlan,
        AdditionalComments
    }
});
</script>
